module.exports = __webpack_public_path__ + "img/indo1.1165bc34.png";